import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import PageTitle from 'hoc/PageTitle';
import CapabilityGroupsTableContainer from 'containers/tables/CapabilityGroupsTableContainer';
import { ADMINAREA_ACCESS, CAPABILITY_GROUP_READ } from 'constants/capabilities';

const ListCapabilityGroupsPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer title="Capability Groups" admin hideDatePicker />}>

        <CapabilityGroupsTableContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Capability Groups', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, CAPABILITY_GROUP_READ] }),
)(ListCapabilityGroupsPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/capabilityGroups/ListCapabilityGroups.js